import { renderBuildFormatActionDateSourceDateTemplate } from '@next-adapter/templates/renderers/generators/actions/action-helpers/build-format-action-date-source.js'
export function buildFormatActionDateSource(options: { exported: boolean }): string {
  return renderBuildFormatActionDateSourceDateTemplate({
    optionsExportedExport: options.exported ? 'export ' : ''
  })
}
